import { render } from "./CertificatesModal.vue?vue&type=template&id=097950af&scoped=true"
import script from "./CertificatesModal.vue?vue&type=script&lang=js"
export * from "./CertificatesModal.vue?vue&type=script&lang=js"

import "./CertificatesModal.vue?vue&type=style&index=0&id=097950af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097950af"]])

export default __exports__